import {useEffect, useRef} from 'react';
import * as css from './SeatmapManage.css';

// LEGACY seat popups. SOLD (.sold-details): ticket-coloured title strip with
// the seat, buyer name, ticket + price, burned hint, and לפרטי העסקה → CRM.
// RESERVED (.details_popup): the partner's reservation with פרטי שריון +
// בחר הכל (select every seat of that partner).

const clampPos = (at) => {
    const W = 280, H = 240;
    const x = Math.min(Math.max(8, at.x - W / 2), (window.innerWidth || 1200) - W - 8);
    const y = Math.min(Math.max(8, at.y + 14), (window.innerHeight || 800) - H - 8);
    return {left: x, top: y};
};

function usePopupClose(onClose) {
    const ref = useRef(null);
    useEffect(() => {
        const h = (e) => { if(ref.current && !ref.current.contains(e.target)) onClose(); };
        // defer so the opening click doesn't immediately close it
        const t = setTimeout(() => document.addEventListener('mousedown', h), 0);
        return () => { clearTimeout(t); document.removeEventListener('mousedown', h); };
    }, [onClose]);
    return ref;
}

export function SoldSeatPopup({seat, at, eid, tickets, onClose}) {
    const ref = usePopupClose(onClose);
    const ticket = tickets.find((t) => t.tid === (seat.soldTid ?? (seat.tids || [])[0]));
    const color = `#${(ticket?.color || '').replace('#', '') || '8b9088'}`;
    const price = seat.paid != null ? seat.paid : ticket?.price;
    return (
        <css.soldPop ref={ref} style={clampPos(at)}>
            <css.soldTitle $color={color}>
                <span>{seat.seat}</span>
                <span>שורה: {seat.row}</span>
                <span className="x" onClick={onClose}>✕</span>
            </css.soldTitle>
            <css.soldBody>
                <div className="name">{seat.buyer || ''}</div>
                <div className="ticket">
                    <span>{ticket?.title || ''}</span>
                    <span className="price">₪{price ?? ''}</span>
                </div>
                {!!seat.enter && <div className="burned">כרטיס שרוף! הלקוח כבר באירוע.</div>}
                <div className="links">
                    <a href={`${window.location.origin}/e/${eid}/crm?oid=${seat.oid}`} target="_blank" rel="noreferrer">לפרטי העסקה</a>
                </div>
            </css.soldBody>
        </css.soldPop>
    );
}

export function ReservedSeatPopup({seat, at, eid, tickets, partners, onClose, onSelectPartnerSeats}) {
    const ref = usePopupClose(onClose);
    const partner = partners.find((p) => p.smpid === seat.smpid);
    const ticket = tickets.find((t) => t.tid === (seat.tids || [])[0]);
    const color = `#${(ticket?.color || '').replace('#', '') || 'f59e0b'}`;
    return (
        <css.soldPop ref={ref} style={clampPos(at)}>
            <css.soldTitle $color={color}>
                <span>{seat.seat}</span>
                <span>שורה: {seat.row}</span>
                <span className="x" onClick={onClose}>✕</span>
            </css.soldTitle>
            <css.soldBody>
                <div className="name">{partner?.title || ''}</div>
                <div className="via">מקום משוריין</div>
                <div className="ticket">
                    <span>{ticket?.title || ''}</span>
                    <span className="price">₪{ticket?.price ?? ''}</span>
                </div>
                <div className="links">
                    <a href={`${window.location.origin}/e/${eid}/tickets/reserved?id=${seat.smpid}`} target="_blank" rel="noreferrer">פרטי שריון</a>
                    <span className="linkBtn" onClick={() => { onSelectPartnerSeats(seat.smpid); onClose(); }}>בחר הכל</span>
                </div>
            </css.soldBody>
        </css.soldPop>
    );
}
